import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { AiAgents } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/AiAgents";
import { ApiAddons } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/ApiAddons";
import { Characteristics } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Characteristics";
import { Community } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Community";
import { CommunityAddons } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/CommunityAddons";
import { CommunityAi } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/CommunityAi";
import { Heading } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Heading";
import { LiveStreams } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/LiveStreams";
import { LiveStreamsAddons } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/LiveStreamsAddons";
import { Services } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Services";
import { Sso } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Sso";
import { Support } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Support";
import { Workflows } from "@circle-react/components/SettingsApp/Plan/RegularPlan/Features/Workflows";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { TierHeaders } from "./TierHeaders";

const localeRoot = "pricing_plans.plan_settings.plan_selection.features";

const Features = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="hidden sm:block">
      <div className="my-12 flex justify-center">
        <Button
          variant="secondary"
          onClick={() => setIsExpanded(prev => !prev)}
          className="mb-6 !text-base"
          aria-expanded={isExpanded}
          aria-controls="features-content"
          large
        >
          {t("pricing_plans.plan_settings.plan_selection.features.toggle_text")}
          <Icon
            type={isExpanded ? "20-chevron-up" : "20-chevron-down"}
            className="ml-1"
          />
        </Button>
      </div>
      {isExpanded && (
        <div id="features-content">
          <Heading>{t([localeRoot, "title"])}</Heading>
          <TierHeaders />
          <Community />
          <Workflows />
          <LiveStreams />
          <Characteristics />
          <CommunityAi />
          <AiAgents />
          <Heading>{t("settings.billing.add_ons.title")}</Heading>
          <CommunityAddons />
          <ApiAddons />
          <LiveStreamsAddons />
          <Sso />
          <Support />
          <Services />
        </div>
      )}
    </div>
  );
};

export default Features;
